import { ChangeEvent, ReactElement, useState } from "react";
import { FormField, TextInput } from "@justworkshr/milo-form";

import { validateEmailStringConditions } from "pages/register/util/fieldValidators";
import useDebounce from "util/useDebounce";
import classNames from "util/classNames";

import styles from "./email-input.module.css";

const isValidEmail = (email: string): boolean => {
  return validateEmailStringConditions(email)[0].isValid;
};

const EmailInput = ({
  email,
  message = "",
  disabled,
  onChange,
  className: classNameArg = "",
}: {
  email: string;
  message?: string;
  disabled?: boolean;
  onChange?: (email: string, isEmailValid: boolean) => void;
  className?: string;
}): ReactElement => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const debouncedSetShowErrorMessage = useDebounce(setShowErrorMessage, 500);
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    const isValid = isValidEmail(email);

    debouncedSetShowErrorMessage(!isValid && !!email.length);
    onChange?.(email, isValid);
  };

  return (
    <div
      className={classNames([
        "email-input-container",
        {
          [styles.containerWithoutError]: !showErrorMessage,
          [classNameArg]: !!classNameArg,
        },
      ])}
    >
      <FormField
        label="Email"
        message={message}
        required={true}
        error={showErrorMessage ? "This is an invalid email address." : ""}
      >
        <TextInput
          name="email"
          value={email}
          disabled={disabled}
          onChange={onInputChange}
        />
      </FormField>
    </div>
  );
};

export default EmailInput;
